import DataTable from 'Components/DataTable';
import FormRow from 'Components/FormRow';
import InputHandler from 'Components/InputHandler';
import BlockWrapper from 'Components/_NewElements/BlockWrapper';
import { fss, IFSS, isLocaleKey } from 'neuro-schemas';
import { arrayOfAll } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';
import { MyServiceContext } from '../..';
import colors from '../../../../../config/theme/colors';

const fssFields = arrayOfAll.keys<Omit<IFSS, 'date'>>()([
  'motivation',
  'exercise',
  'tendency',
  'physicalActivity',
  'problems',
  'sustainedPhysicalActivity',
  'duties',
  'disability',
  'life',
]);

export const Fss = (): React.JSX.Element => {
  const myServContext = React.useContext(MyServiceContext);
  const { editing, setEditingData, locale, viewing } = myServContext;
  const fssData = (editing?.data || viewing?.data) as IFSS & IControlProps;
  const fssLocales = fss.localizations;
  const useLocale = isLocaleKey(locale) ? locale : 'fi';
  const onChangeSurveyForm = (values: TOnChangeValues): void => {
    const field = Object.keys(values)[0];
    const value = Object.values(values)[0];
    setEditingData?.({
      ...fssData,
      [field]: value,
    });
  };

  const totalScore = fss.calculateScore(fssData ?? {});

  return (
    <>
      <BlockWrapper title={viewing ? formatPartialDate(fssData.date) : undefined}>
        {!viewing && (
          <FormRow title={'general.date'} headerWidth={5.3}>
            <InputHandler
              name="date"
              type="PartialDate"
              dateDefault="now"
              formData={{
                document: { date: fssData?.date },
                onChange: onChangeSurveyForm,
              }}
              editing={!!editing}
            />
          </FormRow>
        )}
        <div style={{ color: colors.tertiaryText }}>
          <p>{fssLocales[useLocale]['info']}</p>
          <p>{`${fssLocales[useLocale]['agreeInfo']}, ${fssLocales[useLocale]['disagreeInfo']}`}</p>
        </div>
        <div style={{ width: '60%', marginBottom: '2rem', marginTop: '2rem' }}>
          <DataTable
            headers={['', '', '']}
            data={{
              rowData: fssFields.map(f => {
                const rowSet = [
                  fssLocales[useLocale][`${f}.title`],
                  fssLocales[useLocale][`${f}.description`],
                  <InputHandler
                    key={f}
                    name={f}
                    type="Radio"
                    editing={!!editing}
                    formData={{
                      document: { [f]: fssData?.[f] },
                      onChange: onChangeSurveyForm,
                    }}
                    options={[1, 2, 3, 4, 5, 6, 7]}
                  />,
                ];
                return rowSet;
              }),
              rowStyle: viewing ? undefined : fssFields.map(() => ({ rowAlign: 'top' })),
            }}
          />
        </div>
        <FormRow title="myService.mgravis.fssScore" headerStyle={{ fontWeight: 600 }} headerWidth={7}>
          <div style={{ color: colors.tertiaryText, fontWeight: 600 }}>
            <span>{totalScore || totalScore === 0 ? totalScore : '-'}</span>
          </div>
        </FormRow>
      </BlockWrapper>
      <div style={{ color: colors.tertiaryText, fontStyle: 'italic' }}>
        <p>{fssLocales[useLocale]['reference']}</p>
      </div>
    </>
  );
};
